import script from "./PasswordInput.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordInput.vue?vue&type=script&setup=true&lang=js"

import "./PasswordInput.vue?vue&type=style&index=0&id=6ed223d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ed223d8"]])

export default __exports__